import queryString from 'query-string'
import { filterQueryParams, decamelizeKeys } from '@/utils'
import { LabotestAPI } from './types'

export const labotestApi: LabotestAPI = ky => {
  return {
    async fetch({ patientId, year, isoYear }) {
      const params = decamelizeKeys(filterQueryParams({ year, isoYear }))

      return ky(`patient/${patientId}/labotest/`, {
        method: 'get',
        searchParams: queryString.stringify(params)
      }).json()
    },

    async create({ data, validateOnly = false }) {
      return await ky(`labotest/`, {
        method: 'post',
        json: { data, validateOnly }
      }).json()
    }
  }
}
